import { render, staticRenderFns } from "./ForgottenPasswordForm.vue?vue&type=template&id=066b18c2&"
import script from "./ForgottenPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports